import { h, Component } from 'preact'
import styles from './short-explainer.module.css'
import { EsiInclude } from '../esi-include/esi-include'

export class ShortExplainer extends Component {
  async componentDidMount() {
    if (typeof window !== 'undefined') {
      const Sveip = await import('@nrk/dh-basis-sveip')
      window.customElements.define('dh-basis-sveip', Sveip.default)
    }
  }

  render() {
    const { props } = this
    const mappedItems = props.data?.map((el) => {
      if (el.id) {
        return (
          <div className={styles.item}>
            <div className={styles.titleMedia}>{el.title}</div>
            <EsiInclude className={styles.media} id={el.id} />
          </div>
        )
      }
      return (
        <div className={styles.item}>
          <div className={styles.title}>{el.title}</div>
          {el.text && <p className={styles.paragraph}>{el.text}</p>}
        </div>
      )
    })
    return (
      <div class={styles.sveipWrapper}>
        <dh-basis-sveip className={styles.wrapper}>
          <div data-scroll-container>{mappedItems}</div>
        </dh-basis-sveip>
      </div>
    )
  }
}
